export default __webpack_public_path__ + "static/media/event-4.f77b40ba.jpg";